import dynamic from 'next/dynamic'
import React from 'react'

import { SectionSkeleton } from './SectionSkeleton'

export const Section = dynamic(
  async () => (await import('@/components/MenuSection/Section')).Section,
  { loading: () => <SectionSkeleton /> },
)
